"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const StyledAnimations_1 = require("../../helpers/StyledAnimations");
const StyledFunctions_1 = require("../../helpers/StyledFunctions");
const styles_1 = require("../../styles");
const LoadingIndicator = (0, styled_components_1.default)('div') `
  ${props => (props.center ? 'margin: 0 auto' : '')}
  width: ${props => (props.size ? `${props.size}px` : '16px')};
  height: ${props => (props.size ? `${props.size}px` : '16px')};
  position: relative;
  ${StyledFunctions_1.getMargin};
  &:after {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    border: 2px solid ${props => (props.color ? props.color : styles_1.Colors.Primary)};
    width: 80%;
    height: 80%;
    border-top-color: transparent;
    border-right-color: transparent;
    animation: ${StyledAnimations_1.Rotate360} 500ms infinite linear;
    border-radius: 50%;
  }
`;
exports.default = LoadingIndicator;
